module.exports = __webpack_public_path__ + "static/media/fitness_landing.d150afe6.png";